import * as React from 'react';
import Box from '@mui/material/Box';
import { HoveredTranslationKey } from '../state/useTranslationKeyHover';

type TranslationKeyBadgeProps = {
    hovered: HoveredTranslationKey;
};

function TranslationKeyBadge({ hovered }: TranslationKeyBadgeProps) {
    return (
        <Box
            role="tooltip"
            sx={{
                position: 'fixed',
                top: hovered.y + 14,
                left: hovered.x + 14,
                zIndex: 2000,
                pointerEvents: 'none',
                backgroundColor: 'rgba(33, 33, 33, 0.9)',
                color: '#fff',
                fontFamily: 'monospace',
                fontSize: 12,
                paddingX: 1,
                paddingY: 0.5,
                borderRadius: 1
            }}
        >
            {hovered.key}
        </Box>
    );
}

export default TranslationKeyBadge;
